/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".video-title[_ngcontent-%COMP%]{font-family:Open Sans;font-size:14px;color:#26273b}.video-description[_ngcontent-%COMP%]{font-family:Open Sans;font-size:12px;color:#8e8fa6}.video-close-button[_ngcontent-%COMP%]{padding:0 15px 1px;border:1px solid #acadc1;border-radius:4px;background-color:#fff;background-size:cover;font-family:Open Sans;font-size:16px;color:#26273b;text-align:center}.video-close-button-container[_ngcontent-%COMP%]{display:flex;justify-content:center}.youtube-iframe[_ngcontent-%COMP%]{width:612px;height:345px}"];
export { styles as styles };
